import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ILesson } from '../../../core/models/disciplines';

interface LessonState {
  lessons: ILesson[];
  setLessons: (lessons: ILesson[]) => void;
  resetLesson: () => void;
}

export const useLessonStore = create<LessonState>()(
  persist(
    (set) => ({
      lessons: [],
      setLessons: (lessons: ILesson[]) => set({ lessons: lessons }),
      resetLesson: () => set({
        lessons: [],
      })
    }),
    {
      name: 'discipline-lesson'
    }
  )
);
